const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    LOGOUT: "/auth/logout",
    REFRESH_TOKEN: "/auth/refresh",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    VERIFY_ACCOUNT: "/auth/verify-account",
    RESEND_VERIFICATION: "/auth/resend-verification",
  },
  USER: {
    LOGIN: "/auth/user/sign-in",
    REGISTER: "/users/create",
    /** POST FormData: … interests[category][0] = sub_category name (e.g. interests[legal][0]) */
    VERIFY_OTP: "/user/verify/otp",
    PROFILE: "/user/profile",
    /** POST FormData — legacy path; prefer `updateProfile(userId)` */
    UPDATE_PROFILE: "/user/update/profile",
    /** POST FormData: first_name, last_name, msisdn, location */
    updateProfile: (userId) =>
      `/users/profile/${encodeURIComponent(String(userId))}/update`,
    INSURANCE_APPLICATION: "/user/insurance/application",
    CREATE_REVIEW: "/user/create/review",
    LEADS: "/user/leads",
    CHANGE_PASSWORD: "/user/change-password",
    UPLOAD_AVATAR: "/user/avatar",
    /** POST FormData: user_id, category, sub_category */
    ADD_TOPIC_INTEREST: "/users/add/interest",
    /** POST FormData: consumer_id, user_email */
    PROVIDER_INFO: "/users/provider-info",
  },
  DASHBOARD: {
    OVERVIEW: "/dashboard/overview",
    STATISTICS: "/dashboard/statistics",
  },
  /** Public approved insurance catalog (`?category=` = provider `industry_category_slug`) */
  APPROVED_INSURANCE_PRODUCTS: "/approved/insurance_products",
  CHECK: {
    PHONE: "/check/phone",
    EMAIL: "/check/email",
  },
  /** POST FormData: user_id, user_email, sub_category — gated consumer media library */
  MEDIA: {
    FOR_AUTH_USER: "/media/for-auth-user",
  },
  /** POST FormData: category, sub_category, current_page, query_limit */
  ARTICLES: {
    BY_SUB_CATEGORY: "/articles/by-sub-category",
  },
  /** POST contact / inquiry — swap path when backend is ready */
  CONTACT: {
    SUBMIT: "/inquiry/create",
  },
};

export default API_ENDPOINTS;
